import React from 'react';

import VectorIcon from 'assets/actionPlan/vector.svg';
import CustomDatePicker from 'common-ui/customDatePicker';
import { AsyncSelect } from 'common-ui/select';
import dayjs from 'dayjs';

import { DURATION_TYPE_OPTIONS } from '../../ActionPlanConstans';
import { FormGrid, FormGroup, Subtitle, Title } from '../EmployeeSteps.styles';

const Step1ActionDate = ({
  formData,
  errors,
  submitted,
  isReadOnly,
  handleFieldChange,
  actionsList = [],
  hideAction = false,
  showDuration = false,
  handleKpiChange,
}) => {
  const tomorrow = dayjs().add(1, 'day').startOf('day');

  const maxDate = formData.action?.value
    ? dayjs(actionsList.find((a) => a.id === formData.action.value)?.disableEffectiveDate)
    : null;

  return (
    <>
      {!hideAction && (
        <>
          <Title>Select Action &amp; Effective Date</Title>
          <Subtitle>Action period type</Subtitle>
        </>
      )}

      <FormGrid>
        {showDuration && (
          <FormGroup className="form-kpi">
            <AsyncSelect
              label={
                <>
                  Duration <span style={{ color: 'red' }}>*</span>
                </>
              }
              disabled={isReadOnly}
              defaultOptions
              loadOptions={(inputValue, callback) => {
                callback(
                  DURATION_TYPE_OPTIONS.filter((opt) =>
                    opt.label.toLowerCase().includes((inputValue || '').toLowerCase())
                  )
                );
              }}
              value={formData.kpiConfig.duration}
              onChange={(val) => handleKpiChange('duration', val)}
              $error={errors['kpiConfig.duration']}
            />
          </FormGroup>
        )}
        {!hideAction && (
          <FormGroup>
            <AsyncSelect
              key={actionsList.length}
              label="Action"
              req
              disabled={isReadOnly}
              placeholder="Select an action"
              defaultOptions
              loadOptions={(inputValue, callback) => {
                const options = actionsList.map((a) => ({
                  value: a.id,
                  label: a.pendingActionName || a.actionName,
                }));
                callback(
                  options.filter((opt) =>
                    opt.label.toLowerCase().includes((inputValue || '').toLowerCase())
                  )
                );
              }}
              value={formData.action}
              onChange={(val) => handleFieldChange('action', val)}
              $error={submitted ? errors.action : null}
            />
          </FormGroup>
        )}

        <FormGroup>
          <CustomDatePicker
            label="Effective Date"
            req
            disabled={isReadOnly}
            placeholder="Select a date"
            value={formData.effectiveDate}
            onChange={(val) => handleFieldChange('effectiveDate', val)}
            error={submitted ? errors.effectiveDate : null}
            height="46px"
            minDate={tomorrow}
            maxDate={maxDate}
            slotProps={{ actionBar: { actions: [] } }}
            shouldDisableDate={(date) => {
              const action = actionsList.find((a) => a.id === formData.action?.value);
              const effectiveDate = action?.disableEffectiveDate;
              if (!effectiveDate) return false;
              return dayjs(date).isSame(dayjs(effectiveDate), 'day');
            }}
          />
        </FormGroup>

        <FormGroup>
          <AsyncSelect
            label="Action Type"
            req
            disabled={isReadOnly}
            placeholder="Select a type"
            defaultOptions
            loadOptions={(inputValue, callback) => {
              const options = [
                { value: 'primary', label: 'Primary' },
                { value: 'secondary', label: 'Secondary' },
              ];
              callback(
                options.filter((opt) =>
                  opt.label.toLowerCase().includes(inputValue.toLowerCase())
                )
              );
            }}
            value={formData.actionType}
            onChange={(val) => handleFieldChange('actionType', val)}
            $error={submitted ? errors.actionType : null}
          />
        </FormGroup>

        <FormGroup>
          <AsyncSelect
            label="Estimation Type"
            req
            disabled={isReadOnly}
            placeholder="Select a type"
            defaultOptions
            loadOptions={(inputValue, callback) => {
              const options = [
                { value: 'quantity', label: 'Quantity' },
                { value: 'financial', label: 'Financial' },
                { value: 'both', label: 'Both' },
              ];
              callback(
                options.filter((opt) =>
                  opt.label.toLowerCase().includes(inputValue.toLowerCase())
                )
              );
            }}
            value={formData.estimationType}
            onChange={(val) => handleFieldChange('estimationType', val)}
            $error={submitted ? errors.estimationType : null}
          />
        </FormGroup>
      </FormGrid>
    </>
  );
};

export default Step1ActionDate;
